import React from "react";
import * as styles from "./Link.module.scss";
import { Link as GatsLink } from "gatsby";
import cn from "classnames";
import { Typography as AntTypography } from "antd";
import { SUBJECT_LIST } from "pages/contact-us";

export type LinkStateProps = {
	defaultSubject?: typeof SUBJECT_LIST[number];
	email?: string;
};
// add more state if need

type GenemodLinkProps = {
	className?: string;
	link?: LinkType;
	suffix?: string;
	to?: string;
	internal?: boolean;
	target?: string;
	state?: LinkStateProps;
	children?: any;
	hoverEffect?: boolean;
};

const { Link: AntLink } = AntTypography;

// Props
// internal: boolean; If true, link will lead to internal genemod page using gatsbyLink
// className: string; the className for link style
export default function GenemodLink({
	className,
	link,
	suffix,
	to: propTo,
	internal: propInternal,
	target,
	state,
	children = null,
	hoverEffect = true,
}: GenemodLinkProps) {
	const {
		to = propTo,
		internal = propInternal,
		rel,
	} = link ? LINKS[link] : {};
	const url = `${to}${suffix || ""}`;

	// Get type of link
	if (internal) {
		return (
			<GatsLink
				className={cn(styles, className, {
					[styles.hover]: hoverEffect,
				})}
				to={url}
				state={state}
				target={target}
			>
				{children}
			</GatsLink>
		);
	}

	return (
		<AntLink
			className={cn(styles, className, { [styles.hover]: hoverEffect })}
			href={url}
			target={target}
			rel={rel}
		>
			{children}
		</AntLink>
	);
}

export const LINKS = {
	LANDING: { to: "/", title: "Home", internal: true, rel: "" },
	// Products
	NOTEBOOK: {
		to: "/products/experiments/",
		title: "Experiments",
		internal: true,
		rel: "",
	},
	INVENTORY: {
		to: "/products/virtual-freezers/",
		title: "Virtual freezers",
		internal: true,
		rel: "",
	},
	INTEGRATIONS: {
		to: "/products/integrations/",
		title: "Integrations",
		internal: true,
		rel: "",
	},
	DASHBOARD: {
		to: "/products/alerts/",
		title: "Alerts",
		internal: true,
		rel: "",
	},
	MOLECULAR_BIOLOGY: {
		to: "/product/primer-design/",
		title: "Molecular biology",
		internal: true,
		rel: "",
	},
	CONSUMABLES: {
		to: "/products/lab-consumables/",
		title: "Consumables",
		internal: true,
		rel: "",
	},
	ORDERS: {
		to: "/products/orders/",
		title: "Orders",
	},
	EQUIPMENT: {
		to: "/products/equipments/",
		title: "Equipment",
		internal: true,
		rel: "",
	},
	LIVE_EDITING: {
		to: "/products/reports/",
		title: "Reports",
		internal: true,
		rel: "",
	},
	PROTOCOLS: {
		to: "/products/lab-protocol/",
		title: "Protocols",
		internal: true,
		rel: "",
	},
	INSIGHTS: {
		to: "/products/version-control/",
		title: "Version control",
		internal: true,
		rel: "",
	},
	GENEMOD_AI: {
		to: "/ai-product/",
		title: "Genemod AI",
		internal: true,
		rel: "",
	},
	// Solutions
	BIOPHARMACEUTICAL: {
		to: "/solutions/biopharmaceutical/",
		title: "Biopharmacutical",
		internal: true,
		rel: "",
	},
	BIOTECH: {
		to: "/solutions/industrial-biotech/",
		title: "Industrial biotech",
		internal: true,
		rel: "",
	},
	RESEARCH: {
		to: "/solutions/clinical-research/",
		title: "Clinical research",
		internal: true,
		rel: "",
	},
	MANUFACTURING: {
		to: "/solutions/biomanufacturers/",
		title: "Biomanufacturers",
		internal: true,
		rel: "",
	},
	REPOSITORY: {
		to: "/solutions/biorepositories/",
		title: "Biorepositories",
		internal: true,
		rel: "",
	},
	CRO_CONSULTING: {
		to: "/solutions/cro-consulting/",
		title: "CRO Consulting",
		internal: true,
		rel: "",
	},
	SERVICES: {
		to: "/solutions/contract-services/",
		title: "Contract services",
		internal: true,
		rel: "",
	},
	STARTUPS: {
		to: "/solutions/startups/",
		title: "Startups",
		internal: true,
		rel: "",
	},
	CELL_THERAPY: {
		to: "/solutions/cell-therapy/",
		title: "Cell therapy",
		internal: true,
		rel: "",
	},
	RNA_THERAPY: {
		to: "/solutions/rna-therapy/",
		title: "RNA therapy",
		internal: true,
		rel: "",
	},
	ANTIBODIES: {
		to: "/solutions/antibodies/",
		title: "Antibodies",
		internal: true,
		rel: "",
	},
	CHEMISTRY: {
		to: "/solutions/chemistry/",
		title: "Chemistry",
		internal: true,
		rel: "",
	},
	ACADEMIA: {
		to: "/solutions/academia/",
		title: "Academia",
		internal: true,
		rel: "",
	},
	BIOPHARMA: {
		to: "/solutions/biopharma/",
		title: "Biopharma",
		internal: true,
		rel: "",
	},
	NON_PROFIT: {
		to: "/industry/non-profit/",
		title: "Non-profit",
		internal: true,
		rel: "",
	},
	RESEARCH_AND_DEVELOPMENT: {
		to: "/team/research-and-development/",
		title: "R&D",
		internal: true,
		rel: "",
	},
	MANAGERS: {
		to: "/team/lab-manager/",
		title: "Managers",
		internal: true,
		rel: "",
	},
	ADMIN: {
		to: "/team/life-science-project-management/",
		title: "Admins",
		internal: true,
		rel: "",
	},
	INFORMATION_TECHNOLOGY: {
		to: "/products/security/",
		title: "Security",
		internal: true,
		rel: "",
	},

	// Resources
	VS_EXCEL: {
		to: "/comparisons/excel/",
		title: "vs Excel",
		internal: true,
		rel: "",
	},
	VS_QUARTZY: {
		to: "/comparisons/quartzy/",
		title: "vs Quartzy",
		internal: true,
		rel: "",
	},
	VS_LABARCHIVES: {
		to: "/comparisons/labarchives/",
		title: "vs LabArchives",
		internal: true,
		rel: "",
	},
	VS_FREEZERPRO: {
		to: "/comparisons/freezerpro/",
		title: "vs FreezerPro",
		internal: true,
		rel: "",
	},
	BLOG: { to: "/blog/?category=All", title: "Blog", internal: true, rel: "" },
	EVENTS: { to: "/blog/?category=Events", title: "Blog", internal: true, rel: "" },
	CASE_STUDIES: {
		to: "/case-studies/",
		title: "Case studies",
		internal: true,
		rel: "",
	},
	LIMS: { to: "/lims/", title: "LIMS", internal: true, rel: "" },
	LIMS_SOFTWARE: {
		to: "/lims-software/",
		title: "LIMS Software",
		internal: true,
		rel: "",
	},
	ELN: {
		to: "/product/eln-software/",
		title: "ELN",
		internal: true,
		rel: "",
	},
	ELN_SOFTWARE: {
		to: "/eln-software/",
		title: "ELN",
		internal: true,
		rel: "",
	},
	PROFESSIONAL_SERVICES: {
		to: "/professional-services/",
		title: "Services",
		internal: true,
		rel: "",
	},
	// RESOURCE_PROTOCOLS: {
	// 	to: "/protocols",
	// 	title: "Protocols",
	// 	internal: true,
	// },

	// Company
	ABOUT_US: { to: "/about-us/", title: "About us", internal: true, rel: "" },
	CAREER: { to: "/careers/", title: "Careers", internal: true, rel: "" },
	// PARTNERSHIPS: {
	// 	to: "/partnerships",
	// 	title: "Partnerships",
	// 	internal: true,
	// },
	DEMO: { to: "/demo/", title: "Request demo", internal: true, rel: "" },
	DEMO_V2: { to: "/demo/", title: "REQUEST DEMO", internal: true, rel: "" },
	PRICING: {
		to: "/pricing/",
		title: "Pricing",
		internal: true,
		rel: "",
	},
	CONTACT_US: {
		to: "/contact-us/",
		title: "Contact us",
		internal: true,
		rel: "",
	},
	// SYSTEM_STATUS: {
	// 	to: "/system-status",
	// 	title: "System status",
	// 	internal: true,
	// },

	// Policy
	PRIVACY_POLICY: {
		to: "/privacy-policy/",
		title: "Privacy policy",
		internal: true,
		rel: "",
	},
	TERMS_OF_SERVICE: {
		to: "/terms-of-service/",
		title: "Terms of service",
		internal: true,
		rel: "",
	},
	MSA: { to: "/msa/", title: "MSA", internal: true, rel: "" },
	DPA: {
		to: "/dpa/",
		title: "DPA",
		internal: true,
		rel: "",
	},

	LOGIN: {
		to: `https://app.genemod.net/login`,
		title: "Log In",
		internal: false,
		rel: "nofollow",
	},
	SIGN_UP: {
		to: `https://app.genemod.net/signup`,
		title: "Sign up free",
		internal: false,
		rel: "nofollow",
	},

	SIGN_UP_V2: {
		to: `https://app.genemod.net/signup`,
		title: "Sign Up Now",
		internal: false,
		rel: "nofollow",
	},

	//Socials
	FACEBOOK: {
		to: "https://www.facebook.com/GenemodCorp/",
		title: "Facebook",
		internal: false,
	},
	TWITTER: {
		to: "https://twitter.com/genemod",
		title: "X",
		internal: false,
	},
	INSTAGRAM: {
		to: "https://instagram.com",
		title: "Instagram",
		internal: false,
	},
	LINKEDIN: {
		to: "https://www.linkedin.com/company/genemod/",
		title: "LinkedIn",
		internal: false,
	},
	AWS_COMPLIANCE: {
		to: "https://aws.amazon.com/compliance/programs/",
		title: "AWS Compliance",
		internal: false,
	},

	// Applications
	APPLICATION_ACADEMIA: {
		to: "/application/academia/",
		title: "Academia",
		internal: true,
		rel: "",
	},
	APPLICATION_INSTITUTION: {
		to: "/application/institution/",
		title: "Institution",
		internal: true,
		rel: "",
	},
	BETA: {
		to: "/beta/",
		title: "Beta",
		internal: true,
		rel: "",
	},
	BETA_CODE: {
		to: "/beta-code/",
		title: "Beta code",
		internal: true,
		rel: "",
	},
} as const;

export type LinkType = keyof typeof LINKS;

export const getCurrentPage = (): LinkType => {
	const path = typeof window !== `undefined` && window.location.pathname;
	if (!path || path === "/") {
		return "LANDING";
	}
	const match = Object.entries(LINKS).find(
		([key, { to }]) => key !== "LANDING" && path.startsWith(to)
	);
	return (match?.[0] as LinkType) || "LANDING";
};
